import * as React from 'react';
import { Switch } from './switch';
import { AdSenseForShopping } from './ad-sense-for-shopping';
import { Placeholder } from './placeholder';
import {
    DeviceType,
    Vertical,
    Subvertical,
    Features,
} from '../../shared/types/ast';
import ContentMarketingContainer from './content-marketing/content-marketing-container';

export type PlacementType = 'ast' | 'shopping' | 'content-marketing';

export type Props = {
    id: string;
    className?: string;
    type: PlacementType;
    grid: boolean;
    vertical?: Vertical;
    subvertical?: Subvertical;
    deviceType: DeviceType;
    showBanners: boolean;
    features?: Features;
};

export function Placement(props: Props) {
    const {
        id,
        className,
        type,
        grid,
        vertical,
        subvertical,
        deviceType,
        showBanners,
        features,
    } = props;
    if (showBanners) {
        switch (type) {
            case 'ast':
                return (
                    <Switch
                        id={id}
                        className={className}
                        grid={grid}
                        vertical={vertical}
                        subvertical={subvertical}
                        deviceType={deviceType}
                        features={features}
                    />
                );
            case 'shopping':
                return <AdSenseForShopping id={id} deviceType={deviceType} />;
            case 'content-marketing':
                return <ContentMarketingContainer id={id} />;
        }
    }
    return <Placeholder id={id} />;
}
